// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ToolFilledSvg from "@ant-design/icons-svg/es/asn/ToolFilled";
import AntdIcon from '../components/AntdIcon';

var ToolFilled = function ToolFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ToolFilledSvg
  }));
};

ToolFilled.displayName = 'ToolFilled';
export default React.forwardRef(ToolFilled);